export var StagesSendFunds;
(function (StagesSendFunds) {
    StagesSendFunds["amount"] = "amount";
    StagesSendFunds["selectUser"] = "selectUser";
    StagesSendFunds["verify"] = "verify";
    StagesSendFunds["isLoading"] = "isLoading";
    StagesSendFunds["success"] = "success";
    StagesSendFunds["error"] = "error";
})(StagesSendFunds || (StagesSendFunds = {}));
